import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Required on portaled overlays so RCM CSS variables resolve outside .rcm-root */
export const RCM_PORTAL_CLASS = "rcm-root";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
